
import React from 'react'
import {
    List,
    Datagrid,
    Edit,
    Create,
    SimpleForm,
    DateField,
    TextField,
    ArrayField,
    SingleFieldList,
    EditButton,
    TextInput,
    DateInput,
    Responsive,
    SimpleList,
    SimpleShowLayout,
    ShowButton,
    Show,
    UrlField,
    SelectInput,
    Filter,
    useListContext,
    TopToolbar,
    CreateButton,
    ExportButton,
    Pagination,
    Button,
    ChipField,
    required,
    sanitizeListRestProps,
    SaveButton,
    DeleteButton,
    Toolbar,
    ArrayInput,
    RichTextField,
    SimpleFormIterator,
    NumberInput,
    ReferenceInput,
    ReferenceArrayInput,
    AutocompleteInput,
    AutocompleteArrayInput,
    SelectArrayInput,
    ReferenceField,
    ImageField,
    BooleanField,
    BooleanInput,
    SearchInput,
} from 'react-admin'
import { cloneElement, useMemo } from 'react'
import PropTypes from 'prop-types'
import BookIcon from '@material-ui/icons/Store'
import ShortUrlField from '../Customs/ShortUrlField'
import MultipleField from '../Customs/MultipleField'
import MultipleInput from '../Customs/MultipleInput'
import RichTextInput from 'ra-input-rich-text';
import DeleteAllButton from '../Customs/DeleteAllButton'
import ImportButton from '../Customs/ImportButton'
import DuplicateButton from '../Customs/DuplicateButton'
import MoveFormIterator from '../Customs/MoveFormIterator'
import ApiSelectInput from '../Customs/ApiSelectInput'
import GalleryInput from '../Customs/GalleryInput'

export const ProductIcon = BookIcon

const Product_Filter = (props) => (
    <Filter {...props}>
        <SearchInput source="title" alwaysOn />
        {/* <TextInput source="title" options={{ maxLength: 1024 }} /> */}
        <TextInput source="tag" options={{ maxLength: 1024 }} />
        <TextInput source="category" options={{ maxLength: 1024 }} />
        <BooleanInput source="private" />
        <ReferenceInput source="website" reference="Website" perPage={10000} >
            <AutocompleteInput optionText="ndd" />
        </ReferenceInput>
    </Filter>
)

const ListActions_Store = {}

const ListActions = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        ...rest
    } = props
    let {
        currentSort,
        resource,
        displayedFilters,
        filterValues,
        hasCreate,
        basePath,
        selectedIds,
        showFilter,
        total,
    } = useListContext()
    ListActions_Store.filterValues = filterValues
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            <CreateButton basePath={basePath} />
        </TopToolbar>
    )
}

export const ProductList = (props) => (
    <List {...props} filters={<Product_Filter />} actions={<ListActions />} perPage={10}>
        <Responsive
            small={
                <SimpleList linkType="show"
                    primaryText={record => record ? record.title : ''}
                />
            }
            medium={
                <Datagrid>
                    <TextField source="id" sortable={true} />
                    <TextField source="title" sortable={true} />
                    <TextField source="price" sortable={true} />
                    <ImageField source="preview_media_url" sortable={false} />
                    <MultipleField source="categories" sortable={false} />
                    <MultipleField source="tags" sortable={false} />
                    <BooleanField source="private" sortable={false} />
                    <ReferenceField source="website" reference="Website" >
                        <TextField source="ndd" />
                    </ReferenceField>
                    <DateField source="updatedAt" showTime={true} sortable={true} />
                    <EditButton />
                    <ShowButton />
                    <DuplicateButton tranformFields={[
                        {
                            f: 'title',
                            t: (title) => `${title} copy`
                        },
                        {
                            f: 'private',
                            t: () => true
                        },
                    ]} />
                </Datagrid>
            }
        />
    </List>
)

export const ProductShow = (props) => (
    <Show {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="title" />
            <TextField source="slug_url" />
            <TextField source="description" />
            <TextField source="price" />
            <TextField source="price_promo" />

            <ArrayField source="variant_price">
                <Datagrid>
                    <TextField source="value" color="primary" />
                </Datagrid>
            </ArrayField>
            <ArrayField source="variant_price_promo">
                <Datagrid>
                    <TextField source="value" color="primary" />
                </Datagrid>
            </ArrayField>

            <TextField source="variant1_name" />
            <TextField source="variant1_type" />
            <ArrayField source="variant1_choices">
                <Datagrid>
                    <TextField source="value" color="primary" />
                </Datagrid>
            </ArrayField>
            <ArrayField source="variant1_choices_images_url">
                <Datagrid>
                    <ImageField source="value" color="primary" />
                </Datagrid>
            </ArrayField>

            <TextField source="variant2_name" />
            <TextField source="variant2_type" />
            <ArrayField source="variant2_choices">
                <Datagrid>
                    <TextField source="value" color="primary" />
                </Datagrid>
            </ArrayField>
            <ArrayField source="variant2_choices_images_url">
                <Datagrid>
                    <ImageField source="value" color="primary" />
                </Datagrid>
            </ArrayField>

            <TextField source="variant3_name" />
            <TextField source="variant3_type" />
            <ArrayField source="variant3_choices">
                <Datagrid>
                    <TextField source="value" color="primary" />
                </Datagrid>
            </ArrayField>
            <ArrayField source="variant3_choices_images_url">
                <Datagrid>
                    <ImageField source="value" color="primary" />
                </Datagrid>
            </ArrayField>
            <TextField source="maxByCommand" />
            <TextField source="sku" />
            <MultipleField source="categories" />
            <MultipleField source="tags" />
            <RichTextField source="details" />
            <RichTextField source="info" />
            <ImageField source="preview_media_url" />
            <ArrayField source="images_url">
                <Datagrid>
                    <ImageField source="value" color="primary" />
                </Datagrid>
            </ArrayField>
            <ArrayField source="variant_images_url">
                <Datagrid>
                    <ArrayField source="value">
                        <Datagrid>
                            <ImageField source="value" color="primary" />
                        </Datagrid>
                    </ArrayField>
                </Datagrid>
            </ArrayField>

            <BooleanField source="private" />
            <ArrayField source="shop_links">
                <Datagrid>
                    <UrlField source="value" color="primary" target='_blank' />
                </Datagrid>
            </ArrayField>
            <ArrayField source="media_utils">
                <Datagrid>
                    <ReferenceField source="value" reference="Media" link="show" >
                        <TextField source="s3_key" />
                    </ReferenceField>
                </Datagrid>
            </ArrayField>
            <ReferenceField source="website" reference="Website" >
                <TextField source="ndd" />
            </ReferenceField>

            <DateField source="createdAt" showTime={true} />
            <DateField source="updatedAt" showTime={true} />
        </SimpleShowLayout>
    </Show>
)

const CustomToolBar = props => <Toolbar {...props} ><SaveButton /></Toolbar>

export const ProductEdit = (props) => (
    <Edit {...props} undoable={false} toolbar={<CustomToolBar />} >
        <SimpleForm redirect="show">
            <TextInput source="title" validate={required()} style={{ width: "100%" }} />
            <TextInput source="slug_url" style={{ width: "100%" }} />
            <TextInput source="description" rows={10} multiline style={{ width: "100%" }} />
            <NumberInput source="price" validate={required()} />
            <NumberInput source="price_promo" />

            <ArrayInput source="variant_price">
                <SimpleFormIterator>
                    <NumberInput source="value" />
                </SimpleFormIterator>
            </ArrayInput>
            <ArrayInput source="variant_price_promo">
                <SimpleFormIterator>
                    <NumberInput source="value" />
                </SimpleFormIterator>
            </ArrayInput>


            <TextInput source="variant1_name" />
            <SelectInput source="variant1_type" choices={Array.from(["text", "color", "image"], v => ({ id: v, name: `${v}` }))} />
            <ArrayInput source="variant1_choices">
                <SimpleFormIterator>
                    <TextInput source="value" />
                </SimpleFormIterator>
            </ArrayInput>
            <ArrayInput source="variant1_choices_images">
                <MoveFormIterator>
                    <GalleryInput source="value" />
                </MoveFormIterator>
            </ArrayInput>

            <TextInput source="variant2_name" />
            <SelectInput source="variant2_type" choices={Array.from(["text", "color", "image"], v => ({ id: v, name: `${v}` }))} />
            <ArrayInput source="variant2_choices">
                <SimpleFormIterator>
                    <TextInput source="value" />
                </SimpleFormIterator>
            </ArrayInput>
            <ArrayInput source="variant2_choices_images">
                <MoveFormIterator>
                    <GalleryInput source="value" />
                </MoveFormIterator>
            </ArrayInput>

            <TextInput source="variant3_name" />
            <SelectInput source="variant3_type" choices={Array.from(["text", "color", "image"], v => ({ id: v, name: `${v}` }))} />
            <ArrayInput source="variant3_choices">
                <SimpleFormIterator>
                    <TextInput source="value" />
                </SimpleFormIterator>
            </ArrayInput>
            <ArrayInput source="variant3_choices_images">
                <MoveFormIterator>
                    <GalleryInput source="value" />
                </MoveFormIterator>
            </ArrayInput>
            <NumberInput source="maxByCommand" />
            <TextInput source="sku" />
            <MultipleInput source="categories" />
            <MultipleInput source="tags" />
            <RichTextInput source="details" rows={10} multiline style={{ width: "100%" }} />
            <RichTextInput source="info" rows={10} multiline style={{ width: "100%" }} />
            {/* <ReferenceInput source="preview_media" reference="Media">
                <SelectInput optionText="s3_key" />
            </ReferenceInput> */}
            <GalleryInput source="preview_media" />

            {/* <ReferenceInput source="preview_media" reference="Media" perPage={10000} allowEmpty >
                <AutocompleteInput optionText="s3_key" />
            </ReferenceInput> */}
            {/* <ReferenceArrayInput source="images" reference="Media">
                <SelectArrayInput optionText="s3_key" />
            </ReferenceArrayInput> */}

            {/* <ReferenceArrayInput source="images" reference="Media" perPage={10000} >
                <AutocompleteArrayInput optionText="s3_key" />
            </ReferenceArrayInput> */}

            <ArrayInput source="images">
                <MoveFormIterator>
                    <GalleryInput source="value" />
                </MoveFormIterator>
            </ArrayInput>



            <ArrayInput source="variant_images">
                <MoveFormIterator>
                    <ArrayInput source="value">
                        <MoveFormIterator>
                            <GalleryInput source="value" />
                        </MoveFormIterator>
                    </ArrayInput>

                    {/* <ReferenceArrayInput source="value" reference="Media" perPage={10000} >
                        <AutocompleteArrayInput optionText="s3_key" />
                    </ReferenceArrayInput> */}
                </MoveFormIterator>
            </ArrayInput>

            <BooleanInput source="private" />
            <ArrayInput source="shop_links">
                <SimpleFormIterator>
                    <TextInput source="value" validate={required()} />
                </SimpleFormIterator>
            </ArrayInput>
            <ArrayInput source="media_utils">
                <MoveFormIterator>
                    <GalleryInput source="value" noImage />

                    {/* <ReferenceInput source="value" reference="Media" validate={required()} perPage={10000}>
                        <AutocompleteInput optionText="s3_key" />
                    </ReferenceInput> */}
                </MoveFormIterator>
            </ArrayInput>
            <ReferenceInput source="website" reference="Website" perPage={10000} >
                <AutocompleteInput optionText="ndd" />
            </ReferenceInput>

        </SimpleForm>
    </Edit>
)


export const ProductCreate = (props) => (
    <Create {...props}>
        <SimpleForm redirect="show">
            <TextInput source="title" validate={required()} style={{ width: "100%" }} />
            <TextInput source="slug_url" style={{ width: "100%" }} />
            <TextInput source="description" rows={10} multiline style={{ width: "100%" }} />
            <NumberInput source="price" validate={required()} />
            <NumberInput source="price_promo" />

            <ArrayInput source="variant_price">
                <SimpleFormIterator>
                    <NumberInput source="value" />
                </SimpleFormIterator>
            </ArrayInput>
            <ArrayInput source="variant_price_promo">
                <SimpleFormIterator>
                    <NumberInput source="value" />
                </SimpleFormIterator>
            </ArrayInput>


            <TextInput source="variant1_name" />
            <SelectInput source="variant1_type" choices={Array.from(["text", "color", "image"], v => ({ id: v, name: `${v}` }))} />
            <ArrayInput source="variant1_choices">
                <SimpleFormIterator>
                    <TextInput source="value" />
                </SimpleFormIterator>
            </ArrayInput>
            <ArrayInput source="variant1_choices_images">
                <MoveFormIterator>
                    <GalleryInput source="value" />
                </MoveFormIterator>
            </ArrayInput>

            <TextInput source="variant2_name" />
            <SelectInput source="variant2_type" choices={Array.from(["text", "color", "image"], v => ({ id: v, name: `${v}` }))} />
            <ArrayInput source="variant2_choices">
                <SimpleFormIterator>
                    <TextInput source="value" />
                </SimpleFormIterator>
            </ArrayInput>
            <ArrayInput source="variant2_choices_images">
                <MoveFormIterator>
                    <GalleryInput source="value" />
                </MoveFormIterator>
            </ArrayInput>

            <TextInput source="variant3_name" />
            <SelectInput source="variant3_type" choices={Array.from(["text", "color", "image"], v => ({ id: v, name: `${v}` }))} />
            <ArrayInput source="variant3_choices">
                <SimpleFormIterator>
                    <TextInput source="value" />
                </SimpleFormIterator>
            </ArrayInput>
            <ArrayInput source="variant3_choices_images">
                <MoveFormIterator>
                    <GalleryInput source="value" />
                </MoveFormIterator>
            </ArrayInput>

            <NumberInput source="maxByCommand" />
            <TextInput source="sku" />
            <MultipleInput source="categories" />
            <MultipleInput source="tags" />
            <RichTextInput source="details" rows={10} multiline style={{ width: "100%" }} />
            <RichTextInput source="info" rows={10} multiline style={{ width: "100%" }} />
            {/* <ReferenceInput source="preview_media" reference="Media">
                <SelectInput optionText="s3_key" />
            </ReferenceInput> */}
            <GalleryInput source="preview_media" />

            {/* <ReferenceInput source="preview_media" reference="Media" perPage={10000} >
                <AutocompleteInput optionText="s3_key" />
            </ReferenceInput> */}
            {/* <ReferenceArrayInput source="images" reference="Media">
                <SelectArrayInput optionText="s3_key" />
            </ReferenceArrayInput> */}
            <ArrayInput source="images">
                <MoveFormIterator>
                    <GalleryInput source="value" />
                </MoveFormIterator>
            </ArrayInput>

            {/* <ReferenceArrayInput source="images" reference="Media" perPage={10000}>
                <AutocompleteArrayInput optionText="s3_key" />
            </ReferenceArrayInput> */}

            <ArrayInput source="variant_images">
                <MoveFormIterator>
                    <ArrayInput source="value">
                        <MoveFormIterator>
                            <GalleryInput source="value" noImage />
                        </MoveFormIterator>
                    </ArrayInput>

                    {/* <ReferenceArrayInput source="value" reference="Media" perPage={10000} >
                        <AutocompleteArrayInput optionText="s3_key" />
                    </ReferenceArrayInput> */}
                </MoveFormIterator>
            </ArrayInput>

            <BooleanInput source="private" />
            <ArrayInput source="shop_links">
                <SimpleFormIterator>
                    <TextInput source="value" validate={required()} />
                </SimpleFormIterator>
            </ArrayInput>
            <ArrayInput source="media_utils">
                <SimpleFormIterator>
                    <GalleryInput source="value" noImage />
                    {/* <TextInput source="value" validate={required()} /> */}
                </SimpleFormIterator>
            </ArrayInput>
            <ReferenceInput source="website" reference="Website" perPage={10000} >
                <AutocompleteInput optionText="ndd" />
            </ReferenceInput>

        </SimpleForm>
    </Create>
)
